import { Link } from 'react-router-dom';

const GetApp = () => {
  return (
    <section className="mx-1">
      {/* Desktop Layout */}
      <div className="hidden lg:flex items-center md:px-28 justify-center gap-0 relative">
        {/* Left Card - Steps */}
        <div
          className="rounded-[20px] py-10 px-12 flex flex-col justify-center grow relative z-0"
          style={{
            background: `linear-gradient(328deg, #FFDE11 57.77%, #DB1C5E 120.63%)`,
          }}
        >
          <h2 className="text-[30px] font-semibold text-gray-800 mb-8 leading-tight font-duplet">
            Get all your needs today.
          </h2>

          <div className="space-y-2 text-[23px] flex flex-col items-start">
            <div className="text-gray-800 bg-[#F9BF1D] font-medium  px-4 py-2 rounded-[10px] font-duplet">
              Create your account
            </div>

            <div className="text-gray-800 bg-[#F9BF1D] font-medium  px-4 py-2 rounded-[10px] min-w-[150px] font-duplet">
              Get verified
            </div>

            <div className="text-gray-800 bg-[#F9BF1D] font-medium  px-4 py-2 rounded-[10px] min-w-[150px] font-duplet">
              Start shopping
            </div>
          </div>
        </div>

        {/* Phone Image - Positioned between cards */}
        <div className="relative z-10 -mx-16">
          <img
            src="/images/get-app.min.svg"
            alt="SmallSmall mobile app interface showing iPhone with payment options"
            className=" h-auto object-contain"
            loading="lazy"
          />
        </div>

        {/* Right Card - App Download */}
        <div
          className="rounded-[20px] grow px-14 py-10 flex flex-col justify-between   w-[450px] relative z-0"
          style={{
            background: `linear-gradient(192deg, #FFDE11 56.87%, #DB1C5E 143.57%)`,
          }}
        >
          <div>
            <h2 className="text-[40px] font-semibold text-gray-800 mb-4 leading-10 font-duplet">
              Own today,
              <br />
              pay small small.
            </h2>

            <p className="text-gray-700 mb-8 text-[20px] font-duplet">
              One app for rent, gadgets & life's essentials.
            </p>
          </div>

          <div>
            {/* QR Code */}
            <div className="mb-4">
              <div className="w-20 h-20 bg-transparent rounded-lg p-1 mb-3 border border-black">
                {/* QR code */}
                <img className="w-full" src="/images/qr-code2.svg" alt="" />
              </div>
              <p className="text-base text-gray-700 font-medium font-duplet">
                Scan to pay small small
              </p>
            </div>

            {/* App Store Buttons */}
            <div className="flex gap-4">
              {/* Google Play Button */}
              <Link
                target="_blank"
                to="https://play.google.com/store/apps/details?id=com.smallsmallfair.app&hl=en&pli=1"
                rel="noopener noreferrer"
                className="border-2 border-black rounded-[12px] px-4 py-2 flex items-center gap-3 transition-transform hover:scale-105 w-fit bg-transparent"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="21"
                  height="24"
                  viewBox="0 0 21 24"
                  fill="none"
                >
                  <path
                    d="M9.80506 11.4617L0.0898438 22.0059C0.0907562 22.0078 0.0907561 22.0106 0.0916686 22.0125C0.390051 23.1574 1.41203 24 2.62564 24C3.11108 24 3.56641 23.8656 3.95695 23.6305L3.98798 23.6118L14.9232 17.1593L9.80506 11.4617Z"
                    fill="#EA4335"
                  />
                  <path
                    d="M19.6332 9.66619L19.624 9.65966L14.9029 6.86123L9.58398 11.7013L14.922 17.1582L19.6177 14.3878C20.4407 13.9324 21.0001 13.045 21.0001 12.0223C21.0001 11.0052 20.4489 10.1225 19.6332 9.66619Z"
                    fill="#FBBC04"
                  />
                  <path
                    d="M0.0894234 1.99325C0.0310244 2.21346 0 2.44488 0 2.68376V21.3163C0 21.5552 0.0310245 21.7866 0.0903359 22.0059L10.1386 11.7313L0.0894234 1.99325Z"
                    fill="#4285F4"
                  />
                  <path
                    d="M9.87715 12L14.9049 6.85945L3.9825 0.383598C3.58557 0.140054 3.12203 8.67844e-05 2.62655 8.67844e-05C1.41295 8.67844e-05 0.389138 0.84456 0.0907557 1.99043C0.0907557 1.99136 0.0898438 1.9923 0.0898438 1.99323L9.87715 12Z"
                    fill="#34A853"
                  />
                </svg>
                <div className="flex flex-col">
                  <span className="text-black text-[10px] font-duplet">
                    GET IT ON
                  </span>
                  <span className="text-black text-lg font-medium font-duplet">
                    Google Play
                  </span>
                </div>
              </Link>

              {/* App Store Button */}
              <Link
                target="_blank"
                rel="noopener noreferrer"
                to="https://apps.apple.com/us/app/smallsmall/id6550924061"
                className="border-2 border-black rounded-[12px] px-4 py-2 flex items-center gap-3 transition-transform hover:scale-105 w-fit bg-transparent"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="24"
                  viewBox="0 0 20 24"
                  fill="none"
                >
                  <path
                    d="M16.7045 12.763C16.7166 11.8431 16.9669 10.9411 17.4321 10.141C17.8972 9.34093 18.5621 8.66869 19.3648 8.18687C18.8548 7.47582 18.1821 6.89066 17.4 6.47785C16.6178 6.06505 15.7479 5.83597 14.8592 5.80883C12.9635 5.61456 11.1258 6.91628 10.1598 6.91628C9.17506 6.91628 7.68776 5.82812 6.08616 5.86028C5.05021 5.89296 4.04059 6.18707 3.15568 6.71395C2.27077 7.24083 1.54075 7.98252 1.03674 8.86675C-1.14648 12.5571 0.482005 17.9808 2.57338 20.9639C3.61975 22.4246 4.84264 24.0562 6.44279 23.9984C8.00863 23.9349 8.59344 23.0235 10.4835 23.0235C12.3561 23.0235 12.9048 23.9984 14.5374 23.9616C16.2176 23.9349 17.2762 22.4944 18.2859 21.0198C19.0377 19.979 19.6162 18.8287 20 17.6115C19.0238 17.2084 18.1908 16.5337 17.6048 15.6715C17.0187 14.8093 16.7056 13.7977 16.7045 12.763Z"
                    fill="black"
                  />
                  <path
                    d="M13.6201 3.84713C14.5362 2.77343 14.9875 1.39335 14.8782 0C13.4786 0.143519 12.1857 0.796596 11.2572 1.82911C10.8033 2.33351 10.4556 2.92033 10.234 3.55601C10.0125 4.19168 9.92146 4.86375 9.96613 5.5338C10.6662 5.54084 11.3588 5.3927 11.9917 5.10054C12.6246 4.80838 13.1814 4.37982 13.6201 3.84713Z"
                    fill="black"
                  />
                </svg>
                <div className="flex flex-col">
                  <span className="text-black text-[10px] font-duplet">
                    Download on the
                  </span>
                  <span className="text-black text-lg font-medium font-duplet">
                    App Store
                  </span>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Layout */}
      <div className="lg:hidden relative">
        {/* Card 1 - Steps */}
        <div
          className="rounded-[20px] px-8 pt-8 pb-24 text-center"
          style={{
            background: `linear-gradient(176deg, #FFDE11 55.62%, #DB1C5E 127.31%)`,
          }}
        >
          <h2 className="text-[30px] font-semibold text-gray-800 mb-8 font-duplet">
            Get all your needs today.
          </h2>

          <div className="space-y-1 text-[20px] flex flex-col items-center w-fit mx-auto">
            <div className="text-gray-800 bg-[#F9BF1D] font-medium  px-6 py-3 rounded-[10px] font-duplet w-full text-center">
              Create your account
            </div>
            <div className="text-gray-800 bg-[#F9BF1D] font-medium  px-6 py-3 rounded-[10px] font-duplet w-full text-center">
              Get verified
            </div>
            <div className="text-gray-800 bg-[#F9BF1D] font-medium  px-6 py-3 rounded-[10px] font-duplet w-full text-center">
              Start shopping
            </div>
          </div>
        </div>

        {/* Card 2 - App Download, overlays Card 1 */}
        <div
          className="rounded-t-[20px] -mt-10 px-6 pt-8 pb-0 text-center relative z-10"
          style={{
            background: `linear-gradient(192deg, #FFDE11 56.87%, #DB1C5E 143.57%)`,
          }}
        >
          <h2 className="text-[40px] font-semibold text-gray-800 mb-3 font-duplet">
            Own today,
            <br />
            pay small small.
          </h2>
          <p className="text-gray-700 mb-6 text-[20px] font-duplet">
            One app for rent, gadgets & life's essentials.
          </p>

          {/* QR Code */}
          <div className="mb-6 flex flex-col items-center">
            <p className="text-sm text-gray-700 font-medium font-duplet mb-2">
              Scan to pay small small
            </p>
            <div className="w-20 h-20 rounded-lg overflow-hidden border border-gray-200">
              <img
                src="/images/qr-code.svg"
                alt="QR code to download SmallSmall app"
                className="w-full h-full object-contain bg-white p-1"
              />
            </div>
          </div>

          {/* App Store Buttons - stacked vertically */}
          <div className="flex flex-col gap-3 w-fit mx-auto mb-8">
            {/* App Store Button */}
            <Link
              target="_blank"
              rel="noopener noreferrer"
              to="https://apps.apple.com/us/app/smallsmall/id6550924061"
              className="border-2 border-black rounded-lg p-2 flex items-center gap-3 transition-transform hover:scale-105 w-full bg-transparent"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="24"
                viewBox="0 0 20 24"
                fill="none"
              >
                <path
                  d="M16.7045 12.763C16.7166 11.8431 16.9669 10.9411 17.4321 10.141C17.8972 9.34093 18.5621 8.66869 19.3648 8.18687C18.8548 7.47582 18.1821 6.89066 17.4 6.47785C16.6178 6.06505 15.7479 5.83597 14.8592 5.80883C12.9635 5.61456 11.1258 6.91628 10.1598 6.91628C9.17506 6.91628 7.68776 5.82812 6.08616 5.86028C5.05021 5.89296 4.04059 6.18707 3.15568 6.71395C2.27077 7.24083 1.54075 7.98252 1.03674 8.86675C-1.14648 12.5571 0.482005 17.9808 2.57338 20.9639C3.61975 22.4246 4.84264 24.0562 6.44279 23.9984C8.00863 23.9349 8.59344 23.0235 10.4835 23.0235C12.3561 23.0235 12.9048 23.9984 14.5374 23.9616C16.2176 23.9349 17.2762 22.4944 18.2859 21.0198C19.0377 19.979 19.6162 18.8287 20 17.6115C19.0238 17.2084 18.1908 16.5337 17.6048 15.6715C17.0187 14.8093 16.7056 13.7977 16.7045 12.763Z"
                  fill="black"
                />
                <path
                  d="M13.6201 3.84713C14.5362 2.77343 14.9875 1.39335 14.8782 0C13.4786 0.143519 12.1857 0.796596 11.2572 1.82911C10.8033 2.33351 10.4556 2.92033 10.234 3.55601C10.0125 4.19168 9.92146 4.86375 9.96613 5.5338C10.6662 5.54084 11.3588 5.3927 11.9917 5.10054C12.6246 4.80838 13.1814 4.37982 13.6201 3.84713Z"
                  fill="black"
                />
              </svg>
              <div className="flex flex-col text-left">
                <span className="text-black text-xs font-duplet">
                  Download on the
                </span>
                <span className=" leading-4 text-black text-lg font-bold font-duplet">
                  App Store
                </span>
              </div>
            </Link>

            {/* Google Play Button */}
            <Link
              target="_blank"
              to="https://play.google.com/store/apps/details?id=com.smallsmallfair.app&hl=en&pli=1"
              rel="noopener noreferrer"
              className="border-2 border-black rounded-lg p-2 flex items-center gap-3 transition-transform hover:scale-105 w-full bg-transparent"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M3 20.5V3.5C3 2.91 3.34 2.39 3.84 2.15L13.69 12L3.84 21.85C3.34 21.61 3 21.09 3 20.5Z"
                  fill="#4285F4"
                />
                <path
                  d="M16.81 15.12L6.05 21.34L14.54 12.85L16.81 15.12Z"
                  fill="#34A853"
                />
                <path
                  d="M16.81 8.88L14.54 11.15L6.05 2.66L16.81 8.88Z"
                  fill="#FBBC04"
                />
                <path
                  d="M6.05 21.34C6.4 21.55 6.8 21.52 7.2 21.24L16.81 15.12L14.54 12.85L6.05 21.34Z"
                  fill="#EA4335"
                />
              </svg>
              <div className="flex flex-col text-left">
                <span className="text-black text-xs font-duplet">
                  GET IT ON
                </span>
                <span className=" leading-4 text-black text-lg font-bold font-duplet">
                  Google Play
                </span>
              </div>
            </Link>
          </div>

          {/* Phone Image - bottom of card 2 */}
          <div className="flex justify-center -mx-8">
            <img
              src="/images/get-app-mobile.min.svg"
              alt="SmallSmall mobile app interface"
              className="w-full object-contain"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default GetApp;
